var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgColorAddPlusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_3940_39414)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.5 24C12.1892 24 11.8911 23.8765 11.6714 23.6568C11.4516 23.437 11.3281 23.1389 11.3281 22.8281V1.17188C11.3281 0.861074 11.4516 0.563003 11.6714 0.343234C11.8911 0.123465 12.1892 0 12.5 0C12.8108 0 13.1089 0.123465 13.3286 0.343234C13.5484 0.563003 13.6719 0.861074 13.6719 1.17188V22.8281C13.6719 23.1389 13.5484 23.437 13.3286 23.6568C13.1089 23.8765 12.8108 24 12.5 24Z",
    fill: "#418E05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.3281 13.1719H1.67188C1.36107 13.1719 1.063 13.0484 0.843234 12.8286C0.623465 12.6089 0.5 12.3108 0.5 12C0.5 11.6892 0.623465 11.3911 0.843234 11.1714C1.063 10.9516 1.36107 10.8281 1.67188 10.8281H23.3281C23.6389 10.8281 23.937 10.9516 24.1568 11.1714C24.3765 11.3911 24.5 11.6892 24.5 12C24.5 12.3108 24.3765 12.6089 24.1568 12.8286C23.937 13.0484 23.6389 13.1719 23.3281 13.1719Z",
    fill: "#418E05"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3940_39414"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColorAddPlusIcon);
export default __webpack_public_path__ + "static/media/colorAddPlusIcon.83ed74c6b346991b2bf86f1643382e70.svg";
export { ForwardRef as ReactComponent };